module.exports = __webpack_public_path__ + "assets/img/35_1130.acd93196.jpg";